import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Icon from 'carbon-react/lib/components/icon';

import { SyncHistoryItem as SyncHistoryItemType } from '@futrli-sdk/organisations';

import * as styles from './sync-history.scss';

interface Props {
  entry: SyncHistoryItemType;
}

const DATE_TIME_FORMAT = {
  day: '2-digit' as const,
  hour: '2-digit' as const,
  hour12: false,
  minute: '2-digit' as const,
  month: 'short' as const,
  year: 'numeric' as const
};

export const SyncHistoryItem = ({ entry }: Props) => {
  const intl = useIntl();
  const isSuccess = entry.status === 'sync_success';

  return (
    <li className={styles.item}>
      <span className={styles.status}>
        <Icon
          aria-hidden
          color={isSuccess ? '#00821F' : '#CB374A'}
          focusable={false}
          type={isSuccess ? 'tick_circle' : 'error'}
        />
        <span>
          {isSuccess ? (
            <FormattedMessage id="predict.sync_history.success" defaultMessage="Sync success" />
          ) : (
            <FormattedMessage id="predict.sync_history.failure" defaultMessage="Sync failure" />
          )}
        </span>
      </span>
      <time className={styles.timestamp} dateTime={entry.timestamp}>
        {intl.formatDate(entry.timestamp, DATE_TIME_FORMAT)}
      </time>
    </li>
  );
};
